module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@cian/components");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(4);
exports.CallbackModal = index_1.CallbackModal;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
// tslint:disable:max-file-line-count
var components_1 = __webpack_require__(1);
var React = __webpack_require__(2);
var _1 = __webpack_require__(5);
var _2 = __webpack_require__(7);
var cleanPhone_1 = __webpack_require__(9);
var formatters_1 = __webpack_require__(10);
var time_1 = __webpack_require__(11);
var tracking_1 = __webpack_require__(12);
var style = __webpack_require__(14);
var DEFAULT_CALL_FROM_TIME = '10:00';
var DEFAULT_CALL_TO_TIME = '19:00';
var DEFAULT_HEADER = " \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043C\u0438\u043D\u0443\u0442\u044B";
var NIGHTMODE_HEADER = " \u0432 \u0440\u0430\u0431\u043E\u0447\u0435\u0435 \u0432\u0440\u0435\u043C\u044F";
var EStatus;
(function (EStatus) {
    EStatus[EStatus["default"] = 0] = "default";
    EStatus[EStatus["loading"] = 1] = "loading";
    EStatus[EStatus["final"] = 2] = "final";
})(EStatus = exports.EStatus || (exports.EStatus = {}));
var CallbackModal = (function (_super) {
    tslib_1.__extends(CallbackModal, _super);
    function CallbackModal(props) {
        var _this = _super.call(this, props) || this;
        _this.renderCustomTimezoneText = function () {
            var _a = _this.props, timezoneText = _a.timezoneText, callFrom = _a.callFrom, callTo = _a.callTo;
            return (React.createElement("div", { className: style['time-description'] }, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F \u0432 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0435 \u0441 " + (formatters_1.formatTime(callFrom) || DEFAULT_CALL_FROM_TIME) + " \u0434\u043E " + (formatters_1.formatTime(callTo) || DEFAULT_CALL_TO_TIME) + " \u043F\u043E " + timezoneText + " \u0432\u0440\u0435\u043C\u0435\u043D\u0438"));
        };
        _this.renderDefaultTimezoneText = function () {
            return !time_1.isMoscowTimeZone() &&
                React.createElement("div", { className: style['time-description'] }, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F \u0432 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0435 \u0441 10:00 \u0434\u043E 18:00 \u043F\u043E \u041C\u043E\u0441\u043A\u043E\u0432\u0441\u043A\u043E\u043C\u0443 \u0432\u0440\u0435\u043C\u0435\u043D\u0438");
        };
        _this.handleChangeUserPhoneNumber = function (userPhoneNumber) {
            // Normalize value after mask
            userPhoneNumber = userPhoneNumber.replace(/[^0-9]/g, '');
            _this.setState({
                isValidPhoneNumber: true,
                isPristinePhoneNumber: false,
                errorMessage: '',
                userPhoneNumber: userPhoneNumber,
            });
        };
        /**
         * Open/close section with callback time
         */
        _this.toggleTime = function (e) {
            e.nativeEvent.preventDefault();
            _this.setState({
                timeIsVisible: !_this.state.timeIsVisible,
                timeValue: '',
                isValidTimeValue: true,
                isValidTimeRange: true,
                errorMessage: '',
            });
        };
        _this.handleChangeTime = function (timeValue) {
            _this.setState({
                timeValue: timeValue,
                isValidTimeValue: true,
                isValidTimeRange: true,
                errorMessage: '',
            });
        };
        /**
         * Show section with change callback time
         */
        _this.showTime = function () {
            var _a = _this.state, isValidTimeValue = _a.isValidTimeValue, isValidTimeRange = _a.isValidTimeRange, timeIsVisible = _a.timeIsVisible;
            var _b = _this.props, isTimezoneMode = _b.isTimezoneMode, isNightMode = _b.isNightMode, callFrom = _b.callFrom, callTo = _b.callTo;
            var isCallbackNowEnabled = isTimezoneMode ? !isNightMode : time_1.isWorkTime();
            if (isTimezoneMode ? (!isNightMode && !timeIsVisible) : !timeIsVisible) {
                return (React.createElement(components_1.Link, { linkStyle: style['time-toggle'], href: "#", onClick: _this.toggleTime }, isTimezoneMode ? "\u0423\u043A\u0430\u0437\u0430\u0442\u044C \u0443\u0434\u043E\u0431\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0434\u043B\u044F \u0437\u0432\u043E\u043D\u043A\u0430" : "\u0423\u0434\u043E\u0431\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u0434\u043B\u044F \u0437\u0432\u043E\u043D\u043A\u0430"));
            }
            var timeErrorText = isTimezoneMode
                ? "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F \u0432 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0435 \u0441 " +
                    ((formatters_1.formatTime(callFrom) || DEFAULT_CALL_FROM_TIME) + " \u0434\u043E ") +
                    ("" + (formatters_1.formatTime(callTo) || DEFAULT_CALL_TO_TIME))
                : "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0427\u0427:\u041C\u041C (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, 10:30)";
            var isTimeError = isTimezoneMode
                ? !isValidTimeValue || !isValidTimeRange
                : !isValidTimeValue && isValidTimeRange;
            return (React.createElement("div", { className: style['form-time'] },
                React.createElement("div", tslib_1.__assign({}, components_1.mergeStyles(style['left-part'], style['time-form'])),
                    React.createElement("span", { className: style['time-prefix'] }, "\u0423\u0434\u043E\u0431\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F:"),
                    React.createElement(components_1.Tooltip, { position: components_1.TooltipPosition.RIGHT_CENTER, tooltipContent: (isTimeError ? timeErrorText : '') },
                        React.createElement(components_1.TextField, { invalid: !isValidTimeValue || !isValidTimeRange, placeholder: "10:00", mask: "99:99", containerStyle: style['time-input'], value: _this.state.timeValue, onValueChange: _this.handleChangeTime }))),
                isCallbackNowEnabled &&
                    React.createElement(components_1.Link, { linkStyle: tslib_1.__assign({}, components_1.mergeStyles(style['time-toggle'], style['time-toggle--enabled'])), href: "#", onClick: _this.toggleTime }, "\u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u0441\u0435\u0439\u0447\u0430\u0441")));
        };
        _this.handleSubmit = function (e) {
            e.preventDefault();
            var _a = _this.state, userPhoneNumber = _a.userPhoneNumber, timeValue = _a.timeValue, timeIsVisible = _a.timeIsVisible;
            var _b = _this.props, isTimezoneMode = _b.isTimezoneMode, callFrom = _b.callFrom, callTo = _b.callTo;
            var callFromHHMM = formatters_1.formatTime(callFrom);
            var callToHHMM = formatters_1.formatTime(callTo);
            var isValidPhoneNumber = userPhoneNumber.length === 10;
            var isValidTimeValue = timeIsVisible ? /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(timeValue) : true;
            var hours = +timeValue.split(':')[0];
            var minutes = +timeValue.split(':')[1];
            var callFromHours = +(callFromHHMM || DEFAULT_CALL_FROM_TIME).split(':')[0];
            var callFromMinutes = +(callFromHHMM || DEFAULT_CALL_FROM_TIME).split(':')[1];
            var callToHours = +(callToHHMM || DEFAULT_CALL_TO_TIME).split(':')[0];
            var callToMinutes = +(callToHHMM || DEFAULT_CALL_TO_TIME).split(':')[1];
            var isValidTimeRange = timeIsVisible && !isNaN(hours) ? time_1.isWorkTime(hours) : true;
            if (isTimezoneMode) {
                if (timeIsVisible) {
                    isValidTimeRange = !isNaN(hours)
                        ? time_1.isTimezoneWorkTime(hours, minutes, callFromHours, callFromMinutes, callToHours, callToMinutes)
                        : false;
                }
                else {
                    isValidTimeRange = true;
                    isValidTimeValue = true;
                }
            }
            if (!isValidPhoneNumber || !isValidTimeValue || !isValidTimeRange) {
                _this.setState({
                    isValidPhoneNumber: isValidPhoneNumber,
                    isValidTimeValue: isValidTimeValue,
                    isValidTimeRange: isValidTimeRange,
                    errorMessage: isValidTimeRange || isTimezoneMode
                        ? ''
                        : 'Введите время в интервале с 10:00 до 18:00 по Московскому времени',
                });
                return;
            }
            _this.setState({
                status: EStatus.loading,
            });
            _this.props.requestCallback({
                customerPhone: "+7" + userPhoneNumber,
                agentPhone: _this.props.agentPhone,
                time: timeValue,
                callRightNow: !timeIsVisible,
            }).then(function (result) {
                if (result.success) {
                    if (_this.props.sendAnalytics) {
                        tracking_1.trackCallbackRequestSended(_this.props.gaLabel);
                    }
                    if (_this.props.onSuccess) {
                        _this.props.onSuccess();
                    }
                    _this.setState({
                        status: EStatus.final,
                    });
                }
                else {
                    if (_this.props.onError) {
                        _this.props.onError({ error: result.error, errorcode: result.errorcode });
                    }
                    switch (result.errorcode) {
                        case 1:
                        case 2:
                            _this.setState({
                                status: EStatus.default,
                                isValidTimeValue: false,
                            });
                            break;
                        case 3:
                            _this.setState({
                                status: EStatus.default,
                                isValidPhoneNumber: false,
                            });
                            break;
                        case 4:
                            _this.setState({
                                status: EStatus.final,
                                errorMessage: result.error,
                            });
                            break;
                        case 5:
                            _this.setState({
                                status: EStatus.default,
                                errorMessage: result.error,
                            });
                            break;
                        default:
                            break;
                    }
                }
            }, function () {
                if (_this.props.onError) {
                    _this.props.onError();
                }
                _this.setState({
                    status: EStatus.final,
                    errorMessage: 'Что-то пошло не так! Перезагрузите страницу!',
                });
            });
        };
        if (props.gaLabel) {
            console.warn('gaLabel prop is deprecated. Use onModelOpened & onSuccess callbacks instead');
        }
        var isTimeVisible = props.isTimezoneMode
            ? !!props.isNightMode
            : !time_1.isWorkTime();
        _this.state = {
            userPhoneNumber: cleanPhone_1.cleanPhone(props.userPhoneNumber || ''),
            timeIsVisible: isTimeVisible,
            timeValue: '',
            isValidPhoneNumber: true,
            isPristinePhoneNumber: true,
            isValidTimeValue: true,
            isValidTimeRange: true,
            errorMessage: '',
            status: EStatus.default,
        };
        return _this;
    }
    CallbackModal.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.state, userPhoneNumber = _a.userPhoneNumber, isPristinePhoneNumber = _a.isPristinePhoneNumber;
        if (nextProps.userPhoneNumber) {
            if (isPristinePhoneNumber && (userPhoneNumber !== nextProps.userPhoneNumber)) {
                this.setState(tslib_1.__assign({}, this.state, { userPhoneNumber: cleanPhone_1.cleanPhone(nextProps.userPhoneNumber || '') }));
            }
        }
    };
    CallbackModal.prototype.componentDidMount = function () {
        if (this.props.onModelOpened) {
            this.props.onModelOpened();
            if (this.props.isTimezoneMode && this.phoneInput) {
                this.phoneInput.focus();
            }
        }
    };
    CallbackModal.prototype.render = function () {
        var _this = this;
        var _a = this.state, isValidPhoneNumber = _a.isValidPhoneNumber, userPhoneNumber = _a.userPhoneNumber, errorMessage = _a.errorMessage, status = _a.status;
        var _b = this.props, timezoneText = _b.timezoneText, isTimezoneMode = _b.isTimezoneMode, isNightMode = _b.isNightMode;
        var isCustomTimezoneMessage = isTimezoneMode && timezoneText;
        var isNightModeHeaderEnabled = isTimezoneMode && isNightMode;
        return (React.createElement(components_1.ModalWrapper, { onClose: this.props.close },
            React.createElement(components_1.Modal, { minHeight: 0, minWidth: 500, width: "500px", contentStyle: style['wrapper'], closeBtn: React.createElement(_2.CloseBtn, { isTransparent: true, onClick: this.props.close }) },
                React.createElement("div", { className: style['title'] },
                    "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430, \u0438 \u043C\u044B",
                    React.createElement("br", null),
                    "\u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u043C \u0432\u0430\u043C",
                    isNightModeHeaderEnabled ? NIGHTMODE_HEADER : DEFAULT_HEADER),
                status === EStatus.final ?
                    this.showFinal()
                    :
                        React.createElement("form", { className: style['form'], onSubmit: this.handleSubmit },
                            React.createElement("div", { className: style['left-part'] },
                                React.createElement(components_1.Tooltip, { position: components_1.TooltipPosition.RIGHT_CENTER, tooltipContent: !isValidPhoneNumber ? 'Введите номер' : '' },
                                    React.createElement(components_1.TextField, { ref: function (input) { _this.phoneInput = input; }, invalid: !isValidPhoneNumber, placeholder: "499 765-43-21", mask: "999 999-99-99", value: userPhoneNumber, onValueChange: this.handleChangeUserPhoneNumber, containerStyle: style['phone'], inputStyle: style['phone-input'] }))),
                            React.createElement("span", { style: { marginLeft: 10 } },
                                React.createElement(_1.Button, { type: "submit", buttonStyle: style['submit'], theme: "button/solid", customTheme: this.props.theme === 'pik' ? 'button/pik' : undefined }, "\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043C\u043D\u0435")),
                            this.showTime()),
                (status !== EStatus.final || !this.state.isValidTimeRange) && errorMessage &&
                    React.createElement("div", { className: style['error'] }, errorMessage),
                isCustomTimezoneMessage
                    ? status !== EStatus.final && this.renderCustomTimezoneText()
                    : this.renderDefaultTimezoneText(),
                React.createElement("div", { className: style['description'] }, "\u0426\u0418\u0410\u041D \u043D\u0430\u043F\u0440\u044F\u043C\u0443\u044E \u0441\u043E\u0435\u0434\u0438\u043D\u044F\u0435\u0442 \u043C\u0438\u043B\u043B\u0438\u043E\u043D\u044B \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0432 \u043D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0441 \u043E\u0442\u0434\u0435\u043B\u0430\u043C\u0438 \u043F\u0440\u043E\u0434\u0430\u0436 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430. \u0412\u0430\u0448\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u044B \u0432 \u0440\u0435\u043A\u043B\u0430\u043C\u043D\u044B\u0445 \u0446\u0435\u043B\u044F\u0445 \u0438\u043B\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u044B \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C."),
                status === EStatus.loading &&
                    React.createElement("div", { className: style['preloader-wrapper'] },
                        React.createElement(components_1.Preloader, { size: 50, preloaderStyle: style['preloader'] })))));
    };
    /**
     * Show final message
     */
    CallbackModal.prototype.showFinal = function () {
        var errorMessage = this.state.errorMessage;
        if (errorMessage) {
            return (React.createElement("div", { className: style['final'] }, errorMessage));
        }
        return (React.createElement("div", { className: style['final'] },
            "\u041C\u044B \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u043C \u0432\u0430\u043C \u043D\u0430 \u043D\u043E\u043C\u0435\u0440 ",
            React.createElement("b", null, formatters_1.formatPhone("+7" + this.state.userPhoneNumber)),
            this.state.timeValue && React.createElement("span", null,
                " \u0432 ",
                React.createElement("b", null, this.state.timeValue))));
    };
    return CallbackModal;
}(React.Component));
exports.CallbackModal = CallbackModal;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var components_1 = __webpack_require__(1);
var React = __webpack_require__(2);
var style = __webpack_require__(6);
var Button = (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var customTheme = this.props.customTheme;
        return (React.createElement(components_1.Button, tslib_1.__assign({}, this.props, { buttonStyle: [style['submit'], customTheme === 'button/pik' && style['pik-theme']] }), "\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043C\u043D\u0435"));
    };
    return Button;
}(React.PureComponent));
exports.Button = Button;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pik-theme":"callback_widget-pik-theme-bduhngW5WgW"};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var components_1 = __webpack_require__(1);
var React = __webpack_require__(2);
var style = __webpack_require__(8);
// tslint:disable:max-line-length
var CloseBtn = (function (_super) {
    tslib_1.__extends(CloseBtn, _super);
    function CloseBtn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CloseBtn.prototype.render = function () {
        return (React.createElement("button", tslib_1.__assign({}, components_1.mergeStyles(this.props.className, this.props.isTransparent ? style['button'] : style['button-white']), { onClick: this.props.onClick }),
            React.createElement("div", { className: style['icon-container'] },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14" },
                    React.createElement("path", { fill: "#7A7A7A", fillRule: "evenodd", d: "M2.193.78C2.113.7 1.99.696 1.91.776L.776 1.91c-.078.077-.07.21.002.283L5.585 7 .78 11.807c-.08.08-.083.204-.003.284l1.132 1.134c.076.078.21.07.282-.002L7 8.415l4.807 4.807c.08.08.204.083.284.003l1.134-1.132c.078-.077.07-.21-.002-.283L8.415 7l4.807-4.807c.08-.08.083-.204.003-.284L12.09.775c-.077-.078-.21-.07-.283.002L7 5.585 2.193.78z" })))));
    };
    return CloseBtn;
}(React.Component));
exports.CloseBtn = CloseBtn;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"callback_widget-button-jth7TTyxiws","button-white":"callback_widget-button-white-1B2PWL5DCUs callback_widget-button-jth7TTyxiws","icon-container":"callback_widget-icon-container-6z3Su955e0M"};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanPhone = function (phone) { return phone.replace(/[^\d]/g, ''); };


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function formatPhone(phone, cityCodeNotNecessary) {
    var mask = cityCodeNotNecessary ? '$1 ($2) $3-$4-$5' : '$1 $2 $3-$4-$5';
    if (/^7\d{10}$/.test(phone)) {
        mask = "+" + mask;
    }
    return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, mask);
}
exports.formatPhone = formatPhone;
exports.formatTime = function (time) {
    return time && time.slice(0, 5);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isWorkTime(h) {
    var moscowTimeHours = typeof h === 'number' ? h : new Date().getUTCHours() + 3;
    moscowTimeHours = (moscowTimeHours > 23) ? moscowTimeHours - 24 : moscowTimeHours;
    return moscowTimeHours >= 10 && moscowTimeHours <= 17;
}
exports.isWorkTime = isWorkTime;
function isTimezoneWorkTime(h, m, fromHours, fromMinutes, toHours, toMinutes) {
    var timeHours = (h > 23) ? h - 24 : h;
    var isFromMinutesInRange = timeHours === fromHours ? m >= fromMinutes : true;
    var isToMinutesInRange = timeHours === toHours ? m <= toMinutes : true;
    return (timeHours >= fromHours && isFromMinutesInRange) && (timeHours <= toHours && isToMinutesInRange);
}
exports.isTimezoneWorkTime = isTimezoneWorkTime;
function isMoscowTimeZone() {
    return new Date().getTimezoneOffset() / -60 === 3;
}
exports.isMoscowTimeZone = isMoscowTimeZone;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = __webpack_require__(13);
function trackCallbackRequestSended(label) {
    analytics_1.ca('event', {
        name: 'oldevent',
        category: 'ListingLK',
        action: 'CallBack_popup_send',
        label: label,
    });
}
exports.trackCallbackRequestSended = trackCallbackRequestSended;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports.ca = function ca() {
  if (typeof window === 'undefined') {
    throw new Error("Can't use Cian Analytics without window object!");
  }

  if (!('ca' in window)){
    window.ca = function(evt,params){
      window.ca.q.push([evt,params]);
    };
    window.ca.q = [];
  }

  window.ca.apply(null, arguments);
}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"callback_widget-wrapper-eOFO9Ah5E4A","title":"callback_widget-title-etV0UtvHP2m","left-part":"callback_widget-left-part-kEbPn54RmCq","final":"callback_widget-final-2KEK28d46Qw","form":"callback_widget-form-5aJD9XLlAQE","form-time":"callback_widget-form-time-dwSl8TnyScE","phone":"callback_widget-phone-6a1E76UFbyq","submit":"callback_widget-submit-l5V2mOcYc8I","description":"callback_widget-description-idCcNXteesA","time-toggle":"callback_widget-time-toggle-iHaNGOWIHQQ","time-toggle--enabled":"callback_widget-time-toggle--enabled-fRVUo36ixUs","time-form":"callback_widget-time-form-leaW0agoM0q","time-input":"callback_widget-time-input-9O1tX1WeAga","time-description":"callback_widget-time-description-5RnAcEFfGMI","error":"callback_widget-error-awfONJR7cAi","preloader-wrapper":"callback_widget-preloader-wrapper-8L8gzoNQHuK","preloader":"callback_widget-preloader-lyrPnnd0jYe"};

/***/ })
/******/ ]);
//# sourceMappingURL=callback-widget.js.map